import api from './api';

// Opera Cloud v Opera Cloud — saved comparison configurations (ohip-v-ohip product).
const operaCloudCompareService = {
    list: async (filters = {}) => {
        const params = new URLSearchParams();
        if (filters.partner_id) params.append('partner_id', filters.partner_id);
        if (filters.account_id) params.append('account_id', filters.account_id);
        if (filters.hotel_id) params.append('hotel_id', filters.hotel_id);
        if (filters.active !== undefined) params.append('active', filters.active);
        if (filters.search) params.append('search', filters.search);
        return api.get(`/opera-cloud-compare${params.toString() ? '?' + params.toString() : ''}`);
    },
    get: (id) => api.get(`/opera-cloud-compare/${id}`),
    create: (data) => api.post('/opera-cloud-compare', data),
    update: (id, data) => api.put(`/opera-cloud-compare/${id}`, data),
    remove: (id) => api.delete(`/opera-cloud-compare/${id}`),
    createInvoice: (data) => api.post('/opera-cloud-compare/invoice', data),
    // Fetch one OHIP config endpoint for a side (source|target) of a comparison — the compare engine
    // uses this to pull each instance's configuration codes. `path` is the OHIP config path (with
    // limit/offset already applied by the engine's pagination).
    fetchConfig: (id, side, path) =>
        api.get(`/opera-cloud-compare/${id}/fetch`, { params: { side, path } }),
};

export default operaCloudCompareService;
